import * as E from 'fp-ts/Either';
import * as t from 'io-ts';
import * as td from 'io-ts-types';

import { dateParse } from '../date-parse';

export const DmbDateString = new t.Type<Date, string, unknown>(
  'DmbDateString',
  (i): i is Date => i instanceof Date,
  (u, c) => {
    if (td.date.is(u)) return t.success(u);
    const decoded = t.string.validate(u, c);
    if (E.isLeft(decoded)) {
      return decoded;
    }

    const date = dateParse(decoded.right);
    if (!date || isNaN(date.getTime())) {
      return t.failure(u, c);
    }

    return t.success(date);
  },
  (v) => v.toISOString(),
);

export const NullableDmbDateString = t.union([t.null, DmbDateString]);
